import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AppState, DashboardState, RootState, Dispatcher } from 'AppTypes'

import { LoadingSpinner, LiveStreamWrapper } from '@share/components'
import { UnexpectedError } from '@app/layouts/partials'

import { dashboardActions } from '@features/dashboard/state_management/actions'
import { toast } from '@services'

import { Summary, VideoViewsOverallRanking, VideoViewsCategoryRanking } from './partials'

type Props = {
  appState: AppState
  dashboardState: DashboardState
  dispatch: Dispatcher
}

/* eslint no-debugger: "off" */
/* eslint no-console: "off" */
const Dashboard: React.FC<Props> = ({
  dashboardState: {
    featureInitialed,
    storeStatistic
  },
  dispatch
}) => {
  useEffect(() => {
    dispatch(dashboardActions.initFeature()).then(
      () => {},
      reason => {
        console.log('Dashboard initialed failed', reason)
        toast.error(t('messages.generalErrorMsg'))
      }
    )
  }, [dispatch])

  const { t } = useTranslation()

  if (featureInitialed === 'pending') {
    return (
      <div className="main-content">
        <LoadingSpinner isShowing />
      </div>
    )
  }

  if (featureInitialed === 'rejected') {
    return (
      <UnexpectedError />
    )
  }

  return (
    <div className="main-content">
      <LoadingSpinner />
      <LiveStreamWrapper />
      <Summary />
      <VideoViewsOverallRanking />
      <VideoViewsCategoryRanking />
    </div>
  )
}

export default connect((state: RootState) => ({
  appState: state.app,
  dashboardState: state.dashboard
}))(Dashboard)
